module.exports = __webpack_public_path__ + "img/img_041@2x.0079ac1e.png";